//enums/lifestyleEnums.js

export const SEXUAL_IDENTITIES = [
  "heterosexual",
  "homosexual",
  "bisexual",
  "pansexual",
  "queer",
  "demisexual",
  "asexual",
  "sapiosexual",
  "bicurious",
  "heteroflexible",
  "homoflexible",
  "self_describe",
  "not_select",
];

export const SEXUAL_ROLES = [
  "dominant",
  "submissive",
  "switch",
  "brat",
  "brat_tamer",
  "sensual_romantic",
  "experimental_kinky",
  "voyeur",
  "exhibitionist",
  "service_oriented",
  "role_player",
  "vanilla_gentle",
  "self_describe",
  "not_select",
];

export const BODY_TYPES = [
  "fit_active",
  "curvy_confident",
  "natural_soft",
  "athletic_sensual",
  "in_progress",
];

export const ALCOHOL_CANNABIS = [
  "alcohol_only",
  "cannabis_only",
  "both",
  "none",
];

export const JOIN_HOST = [
  "every_weekend",
  "once_twice_month",
  "every_few_months",
  "occasionally",
  "rarely",
  "never",
];

export const ATTRACTION_GENDERS = [
  "men",
  "women",
  "non_binary_trans",
  "couples",
  "any_vibe",
];

export const CONNECTION_TYPES = [
  "emotional_physical",
  "flirty_fun",
  "lifestyle_swing",
  "deep_sensual_friendship",
  "online_only",
];

export const INTIMACY_TYPES = [
  "kissing_touching",
  "oral_pleasure",
  "slow_sensual_lovemaking",
  "rough_dominant_play",
  "soft_emotional_connection",
  "roleplay_fantasies",
  "kinky_fetish_play",
];

export const SEXUAL_FANTASIES = [
  "threesome_group",
  "dom_sub_play",
  "watching_being_watched",
  "romantic_slow_passion",
  "roleplay_costume",
  "voyeur_exhibition",
  "power_teasing_surrender",
];

export const BODY_ATTRACT = [
  "fit_toned",
  "curvy_soft",
  "athletic_strong",
  "natural_gentle",
  "bold_expressive",
  "unique_variety",
  "open_all",
];

export const SEXUAL_ENVIRONMENTS = [
  "dim_lights_music",
  "bedroom_comfort",
  "shower_hot_tub",
  "outdoor_spontaneous",
  "themed_events",
];

export const EVENT_ATTRACT = [
  "meeting_open_minded",
  "flirty_conversations",
  "dancing_social_spark",
  "exploring_connections",
  "watching_energy",
  "mystery_freedom",
  "all_of_above",
];

export const BE_MATCHED = [
  "couple_to_couple",
  "single_plus_couple",
  "group_trips",
  "mixed_circles",
  "exclusive_parties",
  "private_retreats",
];
